/**
 * Paths dos controladores da API (sem prefixo `/api`).
 * Fonte única compartilhada entre web e API.
 */
export const Endpoints = {
  APP: '_app',
  ASSINATURA: 'assinatura',
  ATUACAO: 'atuacao',
  AUTH: 'auth',
  AUDITORIA_EMAILS: 'auditoria-emails',
  AUDITORIA_TASKS: 'auditoria-tasks',
  AUDITORIA_RATE_LIMIT: 'auditoria-rate-limit',
  CANDIDATO: 'candidato',
  COMARCA: 'comarca',
  CONFIG: 'config',
  CONSELHO_SUPERIOR: 'conselho-superior',
  CURSO: 'curso',
  DASHBOARD: 'dashboard',
  DEFENSOR: 'defensor',
  DEFENSORIA: 'defensoria',
  DIRETORIA: 'diretoria',
  DISTRITO: 'distrito',
  ESTAGIARIO: 'estagiario',
  ESTAGIO: 'estagio',
  ESTAGIO_EVENTOS: 'estagio_eventos',
  FERIADO: 'feriado',
  FOLHA_FREQUENCIA: 'folha_frequencia',
  FUNCAO: 'funcao',
  HISTORICO: 'historico',
  IMPORTACAO: 'importacao',
  INSTITUICAO_ENSINO: 'instituicao_ensino',
  LOTACAO: 'lotacao',
  MOVIMENTACAO: 'movimentacao',
  //MOVIMENTACAOREGISTROS: 'movimentacaoregistros',
  MOVIMENTACAOTIPO: 'movimentacaotipo',
  NUCLEO: 'nucleo',
  NOTIFICACAO: 'notificacao',
  TIPO_GASTO: 'tipo-gasto',
  GASTO: 'gasto',
  PERIODO: 'periodo',
  PESSOA: 'pessoa',
  PREDIO: 'predio',
  PROCESSO_SELETIVO: 'processo-seletivo',
  REGRA: 'regra',
  RELATORIO: 'relatorio',
  /** Relatórios de atividades (defensor / diretoria / corregedoria). */
  RELATORIOS_ATIVIDADES: 'relatorios/atividades',
  RELATORIO_LOTACOES: 'lotacoes-estagiario/fullreport',
  RESPONSAVEL: 'responsavel',
  SETORES: 'setores',
  SIMULADOR_FOLHA: 'simulador-folha',
  SOLAR: 'solar',
  SUBSTITUICAO: 'substituicao',
  TAREFA: 'tarefa',
  USUARIO: 'usuario',
  USUARIOBY: 'usuario/username/info',
  VARA: 'vara',
} as const;

export type EndpointKey = keyof typeof Endpoints;
export type EndpointPath = (typeof Endpoints)[EndpointKey];
